import {
  AsyncThunk,
  createSlice,
  Draft,
  SliceCaseReducers,
} from '@reduxjs/toolkit';
import { TAsyncThunkData } from './store.types';
import { asyncSliceDefaultInitialState } from './store.constants';

export const createCustomSlice = <
  Returned,
  ThunkArg,
  ThunkApiConfig extends { rejectValue?: unknown },
  CustomReducers extends SliceCaseReducers<
    TAsyncThunkData<Returned>
  > = SliceCaseReducers<TAsyncThunkData<Returned>>,
>(
  name: string,
  thunkAction: AsyncThunk<Returned, ThunkArg, ThunkApiConfig>,
  reducers?: CustomReducers,
  callbacks?: {
    onSuccess?: (payload: Returned) => void;
    onError?: (payload: Returned) => void;
    afterReset?: () => void;
  },
  initialState: TAsyncThunkData<Returned> = {
    ...asyncSliceDefaultInitialState,
  } as TAsyncThunkData<Returned>
) => {
  const resetReducer = {
    reset: (state: Draft<TAsyncThunkData<Returned>>) => {
      state.data = null;
      state.isLoading = false;
      state.error = null;

      if (callbacks?.afterReset) {
        callbacks.afterReset();
      }
    },
  };

  return createSlice({
    name,
    initialState,
    // @ts-expect-error - Redux Toolkit has strict validation for merged reducers, but we know these are valid
    reducers: {
      ...reducers,
      ...resetReducer,
    },
    extraReducers: (builder) => {
      builder.addCase(thunkAction.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        // keep existing state.data
      });

      builder.addCase(thunkAction.fulfilled, (state, action) => {
        // @ts-expect-error - Redux Toolkit has strict validation for merged reducers, but we know these are valid
        state.data = action.payload as Draft<Returned>;
        state.isLoading = false;
        state.error = null;
      });

      builder.addCase(thunkAction.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      });
    },
  });
};
